import { TextInputField, CheckboxField } from "@sainsburys-tech/luna-form";
import { Form } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC, useEffect, useState } from "react";
import {
  FIELDS,
  FormInputLevels,
} from "../../../Interfaces/Product/IProductFormField";
import { ProductFormProps } from "../../../Types/Product/ProductFormProps";
import ActionButton from "../../SharedComponents/ActionButton";
import FamilyGroupAutoComplete from "../../SharedComponents/FamilyGroupAutoComplete";
import "../../Product/product.scss";
import { useSelector } from "react-redux";
import { UI_CONSTANTS } from "../../../Constants/constants";
import TooltipComp from "../../SharedComponents/TooltipComp";
import { SelectField } from "@sainsburys-tech/luna-form";
import { ProductTypeOptions } from "../../../Interfaces/IFamilyGroupFormField";
import {
  CheckNotNullAndEmptyAndUndefined,
  removeLastComma,
} from "../../../helpers/StringHelpersMethods";
import { ProductValueType } from "../../../Types/Product/ProductValueType";
import { ProductError } from "../../../Types/Product/ProductError";
import { packSizeToDisplay } from "./FormHelper/productValueTypeFields";

const QueryForm: FC<ProductFormProps> = (props) => {
  const payload = useSelector((state: any) => state.popupReducer);
  const [productTypeDataDisabledState, setProductTypeDataDisabledState] =
    useState<boolean>();
  const isInitialState =
    JSON.stringify(payload?.data?.editPayload?.values) ===
    JSON.stringify(props.values);

  const values = props.values as ProductValueType;
  const errors: ProductError | null | undefined = props.errors && props.errors as ProductError;

  useEffect(() => {
    if (
      CheckNotNullAndEmptyAndUndefined(values.familyGroup) &&
      CheckNotNullAndEmptyAndUndefined(values.productType)
    ) {
      setProductTypeDataDisabledState(true);
    }
  }, [props]);

  const EAN = removeLastComma(values.ean);
  const TUC = removeLastComma(values.tuc);

  return (
    <Container>
      <Form className="o-form">
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.sainId.name}
              label={FormInputLevels.SainId}
              value={values.sainId}
              disabled
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name="displayItemNumber"
              label={FormInputLevels.DisplayItemNumber}
              value={
                values.skuNumber
                  ? values.skuNumber
                  : values.catNumber
              }
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.description.name}
              label={FormInputLevels.Description}
              value={values.description}
              disabled
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.packSize.name}
              label={FormInputLevels.PackSize}
              value={packSizeToDisplay(values)}
              disabled
            />
          </GridItem>

          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <SelectField
              name={FIELDS.productType.name}
              label={FormInputLevels.ProductType}
              options={ProductTypeOptions}
              defaultValue={values.productType}
              error={errors?.productType}
              value={values.productType}
              onChange={props.onChange}
              onBlur={props.onBlur}
              placeholder="Please select"
              disabled={productTypeDataDisabledState}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <h4 style={{ fontSize: "1.125rem" }}>Family Group</h4>
            <FamilyGroupAutoComplete
              productType={values.productType}
              className="family-Group-AutoCompleteModal"
              name="FamilyGroupNew"
              placeholder="Please select"
              testid="autocomplete-field"
              initialValue={values.familyGroup || ""}
              onSelect={(e: any) => {
                if (e === null || e?.value === null) {
                  e = {
                    label: values.familyGroup,
                    value: { desc: values.familyGroup },
                  };
                }
                props.onChange(e, e.label, e.value?.desc, false);
              }}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.familyGroupDescription.name}
              label={FormInputLevels.FamilyGroupDescription}
              value={values.familyGroupDescription}
              disabled
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.tuc.name}
              label={FormInputLevels.TUC}
              value={
                TUC
                  ? TUC.split(",")?.length > 1
                    ? UI_CONSTANTS.MULTI
                    : TUC
                  : TUC
              }
              disabled
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.ean.name}
              label={FormInputLevels.EAN}
              value={
                EAN
                  ? EAN.split(",")?.length > 1
                    ? UI_CONSTANTS.MULTI
                    : EAN
                  : EAN
              }
              disabled
            />
          </GridItem>

          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.createdDate.name}
              label={FormInputLevels.CreatedDate}
              value={values.createdDate}
              disabled
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.updatedDate.name}
              label={FormInputLevels.UpdatedDate}
              value={values.updatedDate}
              disabled
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.updatedBy.name}
              label={FormInputLevels.UpdatedBy}
              value={values.updatedBy}
              disabled
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <div className="checkbox-contain" style={{ display: "flex" }}>
              <div style={{ width: "100%" }}>
                <CheckboxField
                  className="checkBoxOrange"
                  label=""
                  name="NewLine"
                  outlined
                  options={[
                    {
                      value: "New Line",
                      label: FormInputLevels.NewLine,
                    },
                  ]}
                  defaultChecked={values.newLine}
                  disabled
                  fullWidth
                />
              </div>
              {values.newLine && (
                <div style={{ position: "absolute", right: 5 }}>
                  <TooltipComp
                    tooltip={
                      "Please measure weights and dims value of the product under the measurements screen to unset the new product flag."
                    }
                    position="top"
                    messageClass="tooltip-minwidth-30em"
                    tooltipClass="ln-tooltip-info"
                  />
                </div>
              )}
            </div>
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <div className="checkbox-contain">
              <CheckboxField
                className="checkBoxOrange"
                label=""
                name="BreakPackIndicator"
                outlined
                options={[
                  {
                    value: "Break Pack Indicator",
                    label: FormInputLevels.BreakPack,
                  },
                ]}
                defaultChecked={values?.breakPackIndicator}
                disabled
                fullWidth
              />
            </div>
          </GridItem>
        </GridWrapper>
      </Form>
      <ActionButton
        onSubmit={props.onSubmit}
        onClearAll={props.onClearAll}
        onCancel={props.onCancel}
        isAddDisabled={isInitialState}
        isDirty={props.dirty}
        isEdit={props.isEdit}
        isClearButtonRequired={false}
        submitted={props.submitted}
      />
    </Container>
  );
};

export default QueryForm;
